var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGeneralWaiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 0H3.6c-.66 0-1.2.54-1.2 1.2v9.6c0 .66.54 1.2 1.2 1.2h7.2c.66 0 1.2-.54 1.2-1.2V3.6L8.4 0m2.4 10.8H3.6V1.2h4.2v3h3v6.6M1.2 2.4v10.8h9.6v1.2H1.2c-.66 0-1.2-.54-1.2-1.2V2.4h1.2z",
    transform: "translate(-972 -477) translate(959 466) translate(5 5) translate(8.667 6.667) translate(2 1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-972 -477) translate(959 466) translate(5 5) translate(8.667 6.667)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGeneralWaiver);
export default __webpack_public_path__ + "static/media/add-general-waiver.c7f8481503e0ae75d774337cc7f577da.svg";
export { ForwardRef as ReactComponent };